import { useApp } from '../../context/AppContext';
import { formatDate } from '../../utils/helpers';
import Avatar from '../common/Avatar';
import StatsGrid from './StatsGrid';
import ActivityFeed from './ActivityFeed';
import TaskDistribution from './TaskDistribution';
import UpcomingDeadlines from './UpcomingDeadlines';

export default function Dashboard() {
  const { state } = useApp();
  const { currentUser, loading } = state;
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite';

  if (loading) {
    return (
      <div className="p-4 md:p-6 space-y-6 animate-pulse">
        <div className="h-24 bg-slate-100 rounded-2xl" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => <div key={i} className="h-28 bg-slate-100 rounded-2xl" />)}
        </div>
        <div className="h-48 bg-slate-100 rounded-2xl" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="h-64 bg-slate-100 rounded-2xl" />
          <div className="h-64 bg-slate-100 rounded-2xl" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-6">
      <div className="flex items-center gap-4 bg-white rounded-2xl border border-slate-200 p-5 md:p-6">
        <Avatar
          name={currentUser.name}
          color={currentUser.avatarColor}
          size="xl"
          isOnline
        />
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-slate-800">
            {greeting}, {currentUser.name.split(' ')[0]}
          </h2>
          <p className="text-sm text-slate-500 mt-0.5">
            Veja o que está acontecendo nos seus projetos hoje, {formatDate(new Date().toISOString())}
          </p>
        </div>
      </div>

      <StatsGrid />
      <TaskDistribution />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        <ActivityFeed />
        <UpcomingDeadlines />
      </div>
    </div>
  );
}
